import cookie from "js-cookie";
import { apiUrl } from "./apiUrl";

export const auth = {
    getUser: () => {
        let user = window.localStorage.getItem("user");
        user = JSON.parse(user);
        user.sucursalActual = parseInt(
            window.localStorage.getItem("sucursalActual")
        );
        return user;
    },
    getToken: () => {
        return cookie.get("token");
    },
    is: (rol) => {
        return auth.getUser().rol === rol;
    },
    can: (ability) => {
        return auth.permissions[auth.getUser().rol].indexOf(ability) > -1;
    },
    permissions: {
        "super-admin": [
            "editar-usuarios",
            "ver-dashboard",
            "abrir-tarjetas",
            "ver-configuracion",
            "ver-programacion",
            "ver-empleados",
            "ver-nomina",
            "ver-solicitudes",
            "ver-sucursales",
            "ver-reclamaciones",
            "ver-descuentos",
            "ver-vehiculos",
            "ver-rutas",
            "ver-inventario",
            "editar-inventario",
            "ver-gastos-generales",
            "ver-gastos",
            "ver-compras",
            "ver-servicios",
            "ver-reportes",
            "ver-contactos",
        ],
        admin: [
            "ver-dashboard",
            "abrir-tarjetas",
            "ver-configuracion",
            "ver-programacion",
            "ver-empleados",
            "ver-nomina",
            "ver-solicitudes",
            "ver-reclamaciones",
            "ver-descuentos",
            "ver-vehiculos",
            "ver-rutas",
            "ver-inventario",
            "editar-inventario",
            "ver-gastos",
            "ver-gastos-generales",
            "ver-compras",
            "ver-servicios",
            "ver-reportes",
            "ver-contactos",
        ],
        rrhh: [
            "ver-dashboard",
            "ver-configuracion",
            "ver-programacion",
            "ver-empleados",
            "ver-nomina",
            "ver-solicitudes",
            "ver-reclamaciones",
            "ver-vehiculos",
            "ver-rutas",
            "ver-inventario",
            "editar-inventario",
            "ver-gastos",
            "ver-gastos-generales",
            "ver-compras",
            "ver-servicios",
            "ver-reportes",
            "ver-contactos",
        ],
        gasto: [
            "ver-solicitudes",
            "ver-reclamaciones",
            "ver-gastos",
            "ver-gastos-generales",
            "ver-inventario",
            "ver-servicios",
        ],
        digitador: [
            "ver-solicitudes",
            "ver-reclamaciones",
            "ver-empleados",
            "ver-programacion"
        ],
    },
    async authenticate(credentials, cb) {
        const { access_token, user } = credentials;
        cookie.set("token", access_token, { expires: 1 });
        window.localStorage.setItem("user", JSON.stringify(user));
        window.localStorage.setItem("sucursalActual", user.sucursalActual);
        cb();
    },
    async logout() {
        const token = cookie.get("token");
        cookie.remove("token");

        await fetch(apiUrl("salir"), {
            method: "post",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token,
            },
        });

        // to support logging out from all windows
        window.localStorage.setItem("logout", Date.now());
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("sucursalAcual");

        window.location = "/";
    },
    isLoggedIn() {
        const token = cookie.get("token");
        if (!token) {
            return false;
        }
        return token;
    },
    inactivityTime() {
        var time;
        window.onload = resetTimer;

        // DOM Events
        document.onmousemove = resetTimer;
        document.onkeypress = resetTimer;
        document.addEventListener("scroll", resetTimer, true);

        function logout() {
            clearTimeout(time);
            auth.logout();
        }

        function resetTimer() {
            clearTimeout(time);

            if (auth.isLoggedIn()) {
                time = setTimeout(logout, 60000 * 60);
                return;
            }
        }
    },
};
